export default __webpack_public_path__ + "static/media/email.acb8b534.svg";